var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningdark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 47,
    viewBox: "0 0 49 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.3621 35.4508L30.406 4.28115C27.6817 -0.305189 21.0407 -0.311283 18.3128 4.28115L1.35752 35.4508C-1.42742 40.1372 1.9443 46.0718 7.40271 46.0718H41.3155C46.7693 46.0718 50.147 40.142 47.3621 35.4508ZM24.3594 40.4468C22.8089 40.4468 21.5469 39.1847 21.5469 37.6343C21.5469 36.0839 22.8089 34.8218 24.3594 34.8218C25.9098 34.8218 27.1719 36.0839 27.1719 37.6343C27.1719 39.1847 25.9098 40.4468 24.3594 40.4468ZM27.1719 29.1968C27.1719 30.7472 25.9098 32.0093 24.3594 32.0093C22.8089 32.0093 21.5469 30.7472 21.5469 29.1968V15.1343C21.5469 13.5839 22.8089 12.3218 24.3594 12.3218C25.9098 12.3218 27.1719 13.5839 27.1719 15.1343V29.1968Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningdark);
export default __webpack_public_path__ + "static/media/warningdark.af6182e72ec47fb485601a11e9022f90.svg";
export { ForwardRef as ReactComponent };